import $ from 'jquery';
import util from '../util';
import store from '../store';
import * as actions from "../actions";
import designService from '../service/designService';
import Matrix from './matrix';
import History from './history';
import Renderer from './renderer';
import MenuObject from "./menu-object";
import {isElementOffPage} from './component';
import {updateActiveFonts} from "./font";
import Interactable from "./interactable";
import menuObject from "./menu-object";

const REMOVED_CACHE = {};

function getConfig($it) {
    const id = $it.attr('id');
    const cached = REMOVED_CACHE[id];

    const {isInGroup, groupId, $page, $prev, groupWidth, groupHeight} = cached;
    const $group = $(`#${groupId}`);
    const $prevGroup = isInGroup ? $group.prev() : null;

    return {
        id,
        group: $group,
        groupWidth,
        groupHeight,
        page: $page,
        prev: $prev,
        prevGroup: $prevGroup,
        isInGroup,
        isGroupRemoved: false
    }
}

function addToCache($it) {
    const id = $it.attr('id');
    const $group = util.getGroup($it);
    const groupWidth = $group.length > 0 ? $group.width() : 0;
    const groupHeight = $group.length > 0 ? $group.height() : 0;
    const isInGroup = util.isInGroup($it);

    REMOVED_CACHE[id] = {
        isInGroup,
        groupId: $group.attr('id'),
        $page: $it.parents('[data-component="page"]'),
        $prev: $it.prev(),
        groupWidth,
        groupHeight
    };
}

function remove($element) {
    if (util.isPage($element)) return;

    addToCache($element);
    const config = getConfig($element);
    const $group = config.group;

    if (store.getState().isTemplate && util.isIllustration($element)) {
        const illustrationId = $element.attr('data-id');
        if (illustrationId) {
            const $illustrations = $('#canvas').find(`[data-id=${illustrationId}]`);
            if ($illustrations.length <= 1) {
                designService.unlinkIllustration(illustrationId, store.getState().designId);
            }
        }
    }

    if (store.getState().view === 'color-picker') {
        if (util.isText($element)) {
            store.dispatch(actions.goToView('text'));
        }
        if (MenuObject.isMenuObject($element)) {
            store.dispatch(actions.goToView('mo-import'));
        }
        if (util.isFrame($element) || util.isIllustration($element) || util.isImage($element) || util.isShape($element)) {
            store.dispatch(actions.goToView('graphics'));
        }
        if (util.isQrCode($element)) {
            store.dispatch(actions.goToView('qr-codes'));
        }
    }

    Interactable.destroy(Interactable.of($element));
    $element.closest('.page').find(`.page-bars #${$element.attr('id')}`).remove();
    $element.remove();
    Matrix.remove($element.attr('id'));

    updateActiveFonts();

    if ($group.length > 0) {
        const $kids = $group.children('[data-component]');
        if ($kids.length === 0) {
            Matrix.remove($group.attr('id'));
            $group.remove();
            config.isGroupRemoved = true;
        } else {
            Renderer.regroup($group);
        }
    }
}

function restore($element) {
    const {isInGroup, prev, page, group, isGroupRemoved, prevGroup, groupWidth, groupHeight } = getConfig($element);

    if (isInGroup) {
        if (isGroupRemoved) {
            if (prevGroup.length > 0) {
                prevGroup.after(group);
            } else {
                page.find('.content').prepend(group);
            }
        }
        if (prev.length > 0 && $.contains(document, prev[0])) {
            prev.after($element)
        } else {
            group.append($element);
        }
        Renderer.ensureGroupSize(group, groupWidth, groupHeight);
    } else if (prev.length > 0 && $.contains(document, prev[0])) {
        prev.after($element);
    } else {
        page.find('.content').prepend($element);
    }

    if (store.getState().isTemplate && util.isIllustration($element)) {
        const illustrationId = $element.attr('data-id');
        designService.linkIllustration(illustrationId, store.getState().designId);
    }
    util.nextTick(() => {
        Interactable.of($element).afterRestore();
    });
}

function removeElement(data, isArray = false) {
    const elements = !isArray ? [data] : data;

    let toRemove = [];
    if (elements.length > 1) {
        elements.forEach(($it) => {
            toRemove.push(util.isInGroup($it) ? $it.parents('.group') : $it);
        })
    } else {
        toRemove = elements;
    }

    function undo() {
        toRemove.forEach((it) => restore(it));
        menuObject.checkPosDataUsage();
    }
    function redo() {
        toRemove.forEach((it) => remove(it));
        menuObject.checkPosDataUsage();
    }

    redo();
    History.push(undo, redo, 'Remove');
}

function removeElements($elements) {
    const array = [];
    $elements.forEach(($element) => array.push($element));
    removeElement(array, true);
}

function removeElementsOffPage() {
    $('.select').each(function() {
        const $el = $(this);
        if (isElementOffPage($el)) {
            removeElement($el);
        }
    })

}

export default {
    removeElement,
    removeElements,
    removeElementsOffPage
}
